import { useState } from 'react';
import { Alert, Box, Button, Chip, Collapse, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

/**
 * 검수 화면 상단 알림. 오류(확정 차단)와 경고(확인 후 진행) 건수를 요약하고,
 * 펼치면 항목별로 "Go to cell"로 해당 셀에 데려간다. 모두 통과하면 초록 알림 한 줄만 남는다.
 */
export default function ValidationBanner({ validation, onJump }) {
    const [expanded, setExpanded] = useState(true);
    const { errorCount, warningCount, issues } = validation;

    if (!errorCount && !warningCount) {
        return (
            <Alert severity="success" sx={{ py: 0, fontSize: 12, borderRadius: 0, alignItems: 'center' }}>
                <b>Validation passed.</b> Required fields, totals, UOM and party checks are all clear. Ready to confirm.
            </Alert>
        );
    }

    return (
        <Alert
            severity={errorCount > 0 ? 'error' : 'warning'}
            sx={{ py: 0, fontSize: 12, borderRadius: 0, '& .MuiAlert-message': { width: '100%' } }}
            action={
                <Button size="small" color="inherit" onClick={() => setExpanded((v) => !v)} sx={{ fontSize: 11 }}>
                    {expanded ? 'Collapse' : 'Details'}
                </Button>
            }
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                <b>Validation</b>
                {errorCount > 0 && <Chip size="small" color="error" label={`${errorCount} error(s) · blocks confirm`} sx={{ fontSize: 11, height: 20 }} />}
                {warningCount > 0 && <Chip size="small" color="warning" label={`${warningCount} warning(s) · review and proceed`} sx={{ fontSize: 11, height: 20 }} />}
            </Box>
            <Collapse in={expanded}>
                <List dense disablePadding sx={{ maxHeight: 150, overflowY: 'auto', mt: 0.5 }}>
                    {issues.map((issue) => (
                        <ListItemButton key={issue.id} onClick={() => onJump(issue)} sx={{ py: 0.25, px: 1, borderRadius: 1, bgcolor: 'rgba(255,255,255,0.6)', mb: 0.25, '&:hover .go': { opacity: 1 } }}>
                            <Chip size="small" label={issue.type} color={issue.type === 'ERROR' ? 'error' : 'warning'} sx={{ fontSize: 9, height: 16, mr: 1, '& .MuiChip-label': { px: 0.75 } }} />
                            <ListItemText primary={issue.message} secondary={issue.details} primaryTypographyProps={{ fontSize: 12, noWrap: true }} secondaryTypographyProps={{ fontSize: 11, noWrap: true }} sx={{ my: 0 }} />
                            <Typography className="go" sx={{ fontSize: 11, display: 'flex', alignItems: 'center', gap: 0.5, opacity: 0.6, flexShrink: 0, ml: 1 }}>
                                Go to cell <ArrowForwardIcon sx={{ fontSize: 12 }} />
                            </Typography>
                        </ListItemButton>
                    ))}
                </List>
            </Collapse>
        </Alert>
    );
}
